import src from "./bg-desktop-rebrand.jpg";
export default { src: src, aspect: 1.4753246753246754, width: 1136, height: 770 };